import  { forwardRef,  useState } from 'react';
import '../../styles/vendorregistration.css';
import { useTranslation } from 'react-i18next';

const SubscriptionPage = forwardRef(({
    formData,
    updateFormData,
    errors,
    handleFieldFocus,
    plansList
}, ref) => {
    const { t } = useTranslation();
    const [selectedType, setSelectedType] = useState(formData.subscriptionType.type || null);
  
    const handleTypeSelect = (type) => {
        setSelectedType(type);
        updateFormData('subscriptionType', 'type', type);
        handleFieldFocus('subscriptionType', 'type');
    };

    return (
        <div ref={ref}>
            <div className="subscription-type-grid">
                {plansList&&
                    plansList.filter((type, index, self) =>
                        type.version_name !== "Free" ||
                        self.findIndex(t => t.version_name === "Free") === index
                    )
                    .map((type) => (
                        <div
                            key={type.id}
                            className={`vendor-type-option ${selectedType === type ? 'selected' : ''}`}
                            onClick={() => handleTypeSelect(type)}
                        >
                            <div className={`option-icon ${type.id}`}>
                                <span className="icon-placeholder" style={{ display: 'flex' }}>
                                    {type.icon}
                                </span>
                            </div>
                            <span className="option-name">
                                {t(`vendorRegistration.subscriptionTypes.${type.version_name}`)}
                                {type.version_name !== "Free" && (
                                    <span className="discount-price">
                                        {type.pricing ? t('vendorRegistration.subscriptionTypes.monthly') : t('vendorRegistration.subscriptionTypes.yearly')} - ${type.pricing || type.pricing_yearly}
                                    </span>
                                )}
                            </span>
                        </div>
                    ))
                }
            </div>
            <div className="vat-disclaimer-note">
                <i className="fa fa-info-circle"></i>
                <span>{t('vendorRegistration.disclaimer.vatApplicable', '** 13% VAT is applicable on all paid plans')}</span>
            </div>

            {errors.subscriptionType?.type && (
                <div className="error-message vendor-type-error">{t(`vendorRegistration.errors.${errors.subscriptionType?.type}`)}</div>
            )}
        </div>
    )
});
export default SubscriptionPage;